import styled from 'styled-components';

export const StyledPageBottom = styled.div`
  margin: 30px 0;
  text-align: center;

  h4 {
    font-size: ${props => props.theme.fontSizes.small};
    font-weight: normal;
    line-height: 1.2;
    margin: 0 0 10px;
  }

  a {
    font-size: ${props => props.theme.fontSizes.small};
  }

  .or {
    text-transform: lowercase;
    margin: 10px;
    opacity: 0.5;
    font-size: ${props => props.theme.fontSizes.extraSmall};
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}) {
    .or {
      display: block;
    }
  }
`;
